import { useState } from 'react';
import { Link, Grid, Button, Box, IconButton, SvgIcon } from '@mui/material';
import { ImageComponent } from "../../components";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import '../../common/theme/UserFlowPage.scss';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import logo from './../../common/assets/img/agent-account-create-image.png';
import eyeIcon from './../../common/assets/img/visibility.svg'
import ForgotUsernameModal from '../../components/Modal/ForgotUsernameModal'; 
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import { handleFormInputChange } from '../../common/utilities/CustomValidatorUtil';


const ModernLinkLoginPage = (props) => {

    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const initialFormValues = {
        modernlinkUsername: '',
        password: '',
    };

    const defaultTheme = createTheme();
    const { history, setFormValues, isValid, setIsLoading, loaderStyle } = HandleFormUtil(initialFormValues, null, null);
    const handleInputChange = (event) => {
        handleFormInputChange(event, setFormValues);
    };

    const handleContinue = (event) => {
        setIsLoading(true);
    };

    function toggleModal(content){
        setModalContent(content);
        setShowModal(prevState => !prevState);
    }

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

   
    return (
        <div className="userFlow agent-ciam-container">
            <div className="userFlow-container">

                <Grid container justify='space-between' className="container-styling">
                    <Grid item sm={12} md={12} lg={5}>
                        <ImageComponent src={logo} />
                    </Grid>
                    <Grid item sm={12} md={12} lg={7} >
                        <Box>
                            <div className='modernlink-userFlowText licensed-agent'>
                                    <div className="eyebrow">Create an account | Verification </div>
                                    <div className='title'>Verify username and password</div>
                                    <p className='userFlow-content'>This makes sure we link your account to the right information.</p>
                                    <ThemeProvider theme={defaultTheme}>
                                        <form className='modernlink-form-padding-to-continue-button'>
                                            <div className='userFlow-field'>
                                                <div>
                                                    <label htmlFor='modernlinkUsername' >
                                                        modernLink username
                                                    </label>
                                                </div>
                                                <input
                                                    id='modernlinkUsername'
                                                    placeholder='Enter your username'
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className='userFlow-field' >
                                                <div>
                                                    <label htmlFor='password'>
                                                        Password
                                                    </label>
                                                    <div className="password-div">
                                                        <input
                                                            type={showPassword ? 'text' : 'password'}
                                                            id="password"
                                                            name="password"
                                                            placeholder="Enter your password"
                                                            onChange={handleInputChange}
                                                        />
                                                        <img
                                                            className="eye-icon"
                                                            src={eyeIcon}
                                                            alt="eyeIcon"
                                                            onClick={handleTogglePassword}
                                                        />                                               
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="link-container">
                                                <div class="left-link">
                                                    <Link
                                                        className="login-link" onClick={() => toggleModal('forgotUsername')}>
                                                        <span className="login-link-styling">Forgot your modernLink username?</span>
                                                    </Link>
                                                </div>
                                                <div class="right-link">
                                                    <Link
                                                        className="login-link" onClick={() => toggleModal('forgotPassword')}>
                                                        <span className="login-link-styling">Forgot your password?</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                    </ThemeProvider>
                            </div>   
                                
                            <Box className='buttonsBox'>
                                        <Button
                                            disableRipple
                                            disabled={!isValid}
                                            className='button-styling continue-button'
                                            style={loaderStyle}
                                            aria-disabled={!isValid}
                                            onClick={handleContinue}
                                        >
                                            Continue
                                        </Button>
                                        <Button
                                            disableRipple
                                            component={Link}
                                            color='primary'
                                            onClick={() => {  history.goBack()}}
                                            className='back-button'
                                        >
                                            <SvgIcon
                                            className='back-arrow'
                                            component={ArrowBackIosIcon}
                                            />
                                            <span>Back</span>
                                        </Button>
                            </Box>                      
                        </Box>  
                    </Grid>
                </Grid>
            </div>
            
                        

            {showModal &&  modalContent === 'forgotUsername' && <ForgotUsernameModal toggleModal={toggleModal} />}

            {showModal &&  modalContent === 'forgotPassword' && <Box id="forgot-username-modal" className="forgot-username-modal-container">
                <Box className="forgot-username-modal">
                    <Box id="close-modal" className="close-modal"><IconButton
                        aria-label='close'
                        onClick={toggleModal}
                        disableRipple
                        className='close-icon'>
                        <CloseIcon />
                    </IconButton></Box>
                    <Box className="modal-title">Forgot your password?</Box>
                    <Box className="modal-subtitle">We can help!</Box>
                    <Box className="forgotPassword-modal-details">
                        <Box>If you forgot your modernLINK password, we can help you take care of this another way. </Box>
                    </Box>
                    <Box className="modal-buttons">
                        <Button id="dismiss-modal" className="modal-cancel" onClick={() => toggleModal('forgotPassword')} disableRipple>
                            Cancel
                        </Button>

                        <Link className="modal-buttons" href='/userFlow'>
                        <Button id="continue-modal" className="dialog-continue" onClick={() => toggleModal('forgotPassword')} disableRipple>
                            Continue
                        </Button>
                       </Link>
                    </Box>
                </Box>
            </Box>}
        </div>
    );
}


export default ModernLinkLoginPage;
